import React from "react";
import {LangItem} from "../core/Helpers/LangItem";

type TermsConditionsComponentProps = {
};

class TermsConditionsComponent extends React.Component<TermsConditionsComponentProps> {

    constructor(props: TermsConditionsComponentProps) {
        super(props);
    }

    render() {
        return (
            <div className="main-privacy-text">

                <div className={'flex-center'}>
                    <div className='main-privacy-text-title'>
                        <LangItem for={'Terms & Conditions'}/>
                    </div>
                    <div className='main-privacy-text-description'>
                        <LangItem for={'Welcome to the website of Chobal Classic Restoration. By using this site, you agree to the following terms:'}/>
                    </div>
                </div>

                <div className={'flex-center'}>
                    <div className='main-privacy-text-title-42'>
                        1. <LangItem for={'Content usage:'} />
                    </div>
                    <div className="main-privacy-text-description">
                        <LangItem for={'All images, texts, and materials on this website are the intellectual property of Chobal Classic Restoration unless otherwise stated. They may not be copied, reproduced, or used without written permission.'} />
                    </div>
                </div>

                <div className={'flex-center'}>
                    <div className='main-privacy-text-title-42'>
                        2. <LangItem for={'Service descriptions:'} />
                    </div>
                    <div className="main-privacy-text-description">
                        <LangItem for={'All services and project descriptions are provided for informational purposes. They may change without prior notice.'} />
                    </div>
                </div>

                <div className={'flex-center'}>
                    <div className='main-privacy-text-title-42'>
                        3. <LangItem for={'Trademarks disclaimer:'} />
                    </div>
                    <div className="main-privacy-text-description">
                        <LangItem for={'Chobal Classic Restoration is an independent company not affiliated with Mercedes-Benz, Porsche, Land Rover, or any other mentioned brands. All trademarks belong to their respective owners and are used for reference only.'} />
                    </div>
                </div>

                <div className={'flex-center'}>
                    <div className='main-privacy-text-title-42'>
                        4. <LangItem for={'Limitation of liability:'} />
                    </div>
                    <div className="main-privacy-text-description">
                        <LangItem for={'We are not responsible for any loss or damage arising from your use of this website or reliance on its content.'} />
                    </div>
                </div>

                <div className={'flex-center'}>
                    <div className='main-privacy-text-title-42'>
                        5. <LangItem for={'Contact:'} />
                    </div>
                    <div className="main-privacy-text-description">
                        <LangItem for={'For any inquiries, please contact us at'} />
                        <a href="mailto:chobalrestoration@gmail.com" className={'td-none'}><b>{' '}chobalrestoration@gmail.com</b></a>
                    </div>
                </div>
            </div>
        );
    }
}

export {TermsConditionsComponent};
